



















































































































































































































import {
  defineComponent,
  useRoute,
  computed,
  watch,
  ref,
  useContext,
  useFetch,
  onMounted,
  useRouter,
} from '@nuxtjs/composition-api';
import { debounce } from 'lodash-es';
import ProductListItemComponent from '~/components/pages/Product/ProductListItem.vue';
import ProductWineDividedBarGraph from '~/components/pages/Product/ProductWineDividedBarGraph.vue';
import StaffDetailCard from '~/components/pages/Staff/StaffDetailCard.vue';
import StaffProductReviewCard from '~/components/pages/Staff/StaffProductReviewCard.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppSeeMoreButton from '~/components/partials/App/AppSeeMoreButton.vue';
import GlobalHeaderMenu from '~/components/partials/Global/GlobalHeaderMenu.vue';
import LayoutDefault from '~/components/partials/Layout/LayoutDefault.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { LayoutProps } from '~/composables/internals/useLayoutPropsProvider';
import { useStaffFormatDate } from '~/composables/staff/useStaffFormatDate';
import { useCancellable } from '~/composables/useCancellable';
import { useLayoutProps } from '~/composables/useLayoutProps';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { useStore } from '~/composables/useStore';
import { useWOVNio } from '~/composables/wovn/useWOVNio';
import {
  REVIEWS_PER_PAGE,
  MERCHANT_ID,
  CONTENT_TYPE,
  STAFF_REVIEW_SEARCH_SORT_OPTIONS,
  SAME_PRODUCT_OTHER_REVIEW_COUNT,
} from '~/constants';
import { BOTTLE_100, BOTTLE_200, BOTTLE_250 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { PageError } from '~/utils/error';
import { ProductShowECResponseSchema, ProductListItem } from '~/types/modules/product';
import { StaffReview, StaffReviewDetail } from '~/types/modules/staff';
import type { BreadcrumbsItem } from '~/types/ui';
import { FavoriteTypes, BooleanLike, ProductTypeId, ProductCategoryId } from '~/enums';

export default defineComponent({
  components: {
    LayoutDefault,
    AppSeeMoreButton,
    AppIcon,
    AppImage,
    AppLink,
    ProductListItem: ProductListItemComponent,
    ProductWineDividedBarGraph,
    StaffProductReviewCard,
    StaffDetailCard,
    GlobalHeaderMenu,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const { i18n } = useContext();
    const { currentLang } = useWOVNio();
    const { formatDate } = useStaffFormatDate();
    const { IMAGE_WAVE_URL } = useRuntimeConfig();
    const ecDetailResponse = ref<ProductShowECResponseSchema | null>(null);
    const review = ref<StaffReviewDetail | null>(null);
    const otherReviews = ref<StaffReview[]>([]);
    const searchProduct = ref<ProductListItem>();
    const reviewCount = ref(0);
    const otherReviewsAboutThisProduct = ref<StaffReview[]>([]);
    const otherReviewCountAboutThisProduct = ref(0);
    const sort = ref(STAFF_REVIEW_SEARCH_SORT_OPTIONS[0].value);
    const pagination = ref(0);
    const cancellable = useCancellable(['fetchStaffReview']);
    const { fetchAllFavorites } = useListFavorite();

    const isLoadMoreButtonVisible = computed(() => reviewCount.value > otherReviews.value.length);
    const productCode = computed(() => review.value?.main_product.product_code || '');
    const productName = computed(() => review.value?.main_product.name || '');
    const SEOTitle = computed(() => {
      if (!review.value?.user) {
        return '';
      }
      return `${i18n
        .t('Item-22.pageTitle', { itemName: `${productName.value} ${review.value?.user.name}` })
        .toString()}`;
    });

    const { fetch, fetchState } = useFetch(async () => {
      try {
        const { reviewId } = route.value.params;
        review.value = await store.dispatch('modules/staff/fetchStaffReviewDetail', { reviewId });
        const { items, total } = await store.dispatch('modules/staff/fetchStaffReviewList', {
          staffId: String(review.value.user.user_id),
          offset: pagination.value * REVIEWS_PER_PAGE,
          cancelToken: cancellable.token('fetchStaffReview'),
        });
        otherReviews.value = [...otherReviews.value, ...items];
        reviewCount.value = total;
      } catch {
        // レビューが見つからなかったら404に遷移
        throw new PageError(404, {});
      }

      try {
        const { items, total } = await store.dispatch('modules/staff/fetchStaffReviewList', {
          productCode: productCode.value,
          sort: sort.value,
          offset: pagination.value * REVIEWS_PER_PAGE,
          cancelToken: cancellable.token('fetchStaffReview'),
        });
        otherReviewsAboutThisProduct.value = [...otherReviewsAboutThisProduct.value, ...items];
        otherReviewCountAboutThisProduct.value = total;
      } catch {
        // レビューが見つからなかったら404に遷移
        throw new PageError(404, {});
      }

      try {
        ecDetailResponse.value = await store.dispatch('product/detail/fetchECProductDetail', {
          path: { code: productCode.value },
        });
        // 商品種別がプリムールだったら404
        if (ecDetailResponse.value?.type_id === ProductTypeId.PRIMEUR) {
          throw new PageError(404, {});
        }
      } catch {
        throw new PageError(404, {});
      }

      try {
        const { items } = await store.dispatch('modules/product/fetchProducts', {
          q: `mst:product AND product_code_s: ${productCode.value}`,
        });
        searchProduct.value = items[0];
      } catch {
        throw new PageError(404, {});
      }
    });

    onMounted(() => {
      // スタッフスタートPV計測タグ
      if (window.staffStart) {
        try {
          const { reviewId } = route.value.params;
          window.staffStart.pv.sendTrackingRequest(MERCHANT_ID, {
            content_type: CONTENT_TYPE,
            content_id: reviewId,
            user_id: userCardNo.value,
          });
        } catch {
          // 何もしない
        }
      }
      fetchAllFavorites(FavoriteTypes.ITEM);
    });

    useLayoutProps(() => {
      const breadcrumbs: BreadcrumbsItem[] = [];
      const layoutProps: LayoutProps = {
        layout: {
          header: 'always',
          headerMenu: 'never',
        },
        head: {
          title: SEOTitle.value,
          description: i18n.t('Item-22.description').toString(),
        },
        breadcrumbs,
        fetchState,
      };

      if (!ecDetailResponse.value) {
        return layoutProps;
      }

      const { categories, master_settings } = ecDetailResponse.value;

      const path = url('ITEM_LIST');
      /**
       * 商品に紐づけられている要素を順番にパンくずへ反映させる
       * 並び順は下記の通りとなる
       * (ワイン通販エノテカ > )カテゴリ名(複数階層あれば > で繋げる) > カラー名 > 生産地名(複数階層あれば > で繋げる) > 生産者名 > 「スタッフ名」のスタッフレビュー
       * ※ワインカテゴリのクエリはパンくずではつけない
       */
      const categoryIds = categories
        .map(({ id }) => id.toString())
        .filter((id) => id !== ProductCategoryId.WINE.toString());
      categories.forEach((category, index) => {
        breadcrumbs.push({
          title: category.name,
          to: { path, query: { _ctg: categoryIds.slice(0, index + 1), _qty: BooleanLike.TRUE } },
        });
      });
      if (master_settings?.color && master_settings.color.name && master_settings.color.id) {
        breadcrumbs.push({
          title: master_settings.color.name,
          to: { path, query: { _color: master_settings.color.id.toString(), _qty: BooleanLike.TRUE } },
        });
      }
      if (master_settings?.producing_areas) {
        master_settings.producing_areas.forEach((area) => {
          if (area.id && area.name) {
            breadcrumbs.push({
              title: area.name,
              to: { path, query: { _area: area.id.toString(), _qty: BooleanLike.TRUE } },
            });
          }
        });
      }
      if (master_settings?.producer && master_settings?.producer?.name_kana && master_settings?.producer?.id) {
        breadcrumbs.push({
          title: master_settings.producer.name_kana,
          to: { path, query: { _producers: master_settings.producer.id.toString(), _qty: BooleanLike.TRUE } },
        });
      }
      breadcrumbs.push({ title: productName.value, to: url('ITEM_DETAIL', { code: productCode.value }) });
      breadcrumbs.push({
        title: i18n
          .t('Item-22.pageTitle', { itemName: `${productName.value}${review.value?.user.name ?? ''}` })
          .toString(),
        to: null,
      });

      return layoutProps;
    });

    // 表示中のレビューを排除（このスタッフの他のレビュー）
    const filterdOtherReviews = computed(() => {
      if (review.value == null) {
        return [];
      }
      return otherReviews.value.filter((otherReview) => otherReview.id !== review.value?.id);
    });

    watch(
      () => route.value.params,
      debounce(async () => {
        cancellable.cancel(['fetchStaffReview']);
        await fetch();
      })
    );

    // 表示中のレビューを排除（このワインに関連する他のレビュー）
    const filterdOtherReviewsAboutThisProduct = computed(() => {
      if (review.value == null) {
        return [];
      }
      return otherReviewsAboutThisProduct.value
        .filter((otherReview) => otherReview.id !== review.value?.id)
        .filter((review, index) => index < SAME_PRODUCT_OTHER_REVIEW_COUNT);
    });

    watch(
      () => route.value.params,
      debounce(async () => {
        cancellable.cancel(['fetchStaffReview']);
        await fetch();
      })
    );

    // 会員番号（計測タグ用）
    const userCardNo = computed(() => store.state.user.info.userBase?.cardNo);

    const applyFilter = async (tag: number) => {
      const tagAsString = tag.toString();
      await router.push({ path: url('STAFF_REVIEW_LIST'), query: { _tag: tagAsString } });
    };

    return {
      review,
      searchProduct,
      fetchState,
      formatDate,
      currentLang,
      otherReviews,
      otherReviewsAboutThisProduct,
      otherReviewCountAboutThisProduct,
      url,
      filterdOtherReviews,
      filterdOtherReviewsAboutThisProduct,
      isLoadMoreButtonVisible,
      MERCHANT_ID,
      CONTENT_TYPE,
      userCardNo,
      sort,
      pagination,
      applyFilter,
      SEOTitle,
      BOTTLE_100,
      BOTTLE_200,
      BOTTLE_250,
      IMAGE_WAVE_URL,
      ecDetailResponse,
    };
  },
});
